import produce from 'immer';

// TYPES
import { Types, consultaCadastroCnh } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: consultaCadastroCnh = {
	status: 0,
	data: null,
};

export default function consultaCadastroCnhReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaCadastroCnh {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CADASTRO_CNH: {
				break;
			}

			case Types.CONSULTA_CADASTRO_CNH_SUCCESS: {
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_CADASTRO_CNH_FAILURE: {
				break;
			}

			default:
		}
	});
}
